import React from "react";
import { get } from "lodash";
import { TYPE } from "APP_ROOT/constants";
import { SO_ITEM } from "MODULES/Orders/shared/constants";
import { RMA } from "MODULES/Receiving/constants";
import { Warning } from "MODULES/shared/components";
import { SERIAL_NUMBER } from "MODULES/inventories/constants";

function DupeWarning({ receivingRecord }) {
  if (
    (get(receivingRecord, TYPE) === SO_ITEM &&
      get(receivingRecord, "customer_rma.received") === false) ||
    (get(receivingRecord, TYPE) === RMA &&
      get(receivingRecord, "sales_item.exchange_sale") &&
      !get(receivingRecord, "sales_item.received"))
  ) {
    return (
      <Warning>
        Warning: Serial #{get(receivingRecord, SERIAL_NUMBER)} exists more than
        once in the Inbound. You have selected the{" "}
        {get(receivingRecord, TYPE) === RMA ? "RMA" : "SO"}. Please verify you
        selected the correct line item.
      </Warning>
    );
  }

  return null;
}

export default DupeWarning;



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/Warnings/DupeWarning.jsx